/* eslint-disable @typescript-eslint/no-empty-function */
import Bole from '@haptik/helpers/build/esm/bole';

import {
  FETCH_ECTS_LOADING,
  FETCH_ECTS_SUCCESS,
  FETCH_ECTS_ERROR,
  FETCH_ECT_LOADING,
  FETCH_ECT_SUCCESS,
  FETCH_ECT_ERROR,
  CREATE_ECT_LOADING,
  CREATE_ECT_SUCCESS,
  CREATE_ECT_ERROR,
  UPDATE_ECT_LOADING,
  UPDATE_ECT_SUCCESS,
  UPDATE_ECT_ERROR,
  DELETE_ECT_LOADING,
  DELETE_ECT_SUCCESS,
  DELETE_ECT_ERROR,
  ACTIVATE_INVALID_BOT_DIALOGUE,
  DEACTIVATE_INVALID_BOT_DIALOGUE,
  ACTIVATE_CONTACT_SALES_TEAM_DIALOGUE,
  DEACTIVATE_CONTACT_SALES_TEAM_DIALOGUE,
} from './actionTypes';

import {
  ECT_CREDENTIALS,
  ERROR_MESSAGE_FETCH,
  ERROR_MESSAGE_SAVE,
  ERROR_MESSAGE_DELETE,
  ZOHO_FQDN,
} from '../const';

import {
  getAllECTsForClient,
  getECTForClient,
  setupECTForClient,
  updateECTForClient,
  deleteEctForClient,
} from './apis';
import { getAuthoriseURL } from '../components/Setup/Zoho/actions';

export const fetchECT = (clientId, fqdn, cb = () => {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_ECT_LOADING });
      const response = await getECTForClient(clientId, fqdn);
      let zohoAuthResponse = {};
      if (!response?.response?.success)
        throw new Error(response?.response?.error);
      if (fqdn === ZOHO_FQDN) {
        zohoAuthResponse = await getAuthoriseURL();
      }
      const { body, meta } = response.response;
      dispatch({
        type: FETCH_ECT_SUCCESS,
        payload: {
          ...body,
          ...meta,
          zohoAuthResponse: zohoAuthResponse.response?.body,
        },
      });
      cb(response?.response?.body);
    } catch (error) {
      dispatch({ type: FETCH_ECT_ERROR, payload: { fqdn } });
      Bole.alert(ERROR_MESSAGE_FETCH);
    }
  };
};

export const fetchECTs = (clientId, fqdn, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_ECTS_LOADING });
      const response = await getAllECTsForClient(clientId);
      if (!response?.response?.success)
        throw new Error(response?.response?.error);
      dispatch({ type: FETCH_ECTS_SUCCESS, payload: response.response.body });
      // Following API call is required to make sure we call APIs in serial
      if (fqdn && ECT_CREDENTIALS[fqdn]) fetchECT(clientId, fqdn, cb)(dispatch);
    } catch (error) {
      dispatch({ type: FETCH_ECTS_ERROR });
      Bole.alert(ERROR_MESSAGE_FETCH);
    }
  };
};

export const createECT = (
  clientId,
  businessId,
  fqdn,
  credentials,
  prevCredentials,
  callbackURL,
  onFail = () => {}
) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_ECT_LOADING,
        payload: { configuration: { credentials, ect_fqdn: fqdn } },
      });
      const response = await setupECTForClient(
        clientId,
        businessId,
        fqdn,
        credentials,
        callbackURL
      );
      if (!response?.response?.success)
        throw new Error(response?.response?.error);
      dispatch({
        type: CREATE_ECT_SUCCESS,
        payload: { configuration: { credentials, ect_fqdn: fqdn } },
      });
    } catch (error) {
      dispatch({
        type: CREATE_ECT_ERROR,
        payload: {
          configuration: { credentials: prevCredentials, ect_fqdn: fqdn },
        },
      });
      onFail();
      Bole.alert(ERROR_MESSAGE_SAVE);
    }
  };
};

export const updateECT = (
  clientId,
  businessId,
  fqdn,
  credentials,
  prevCredentials,
  onFail = () => {}
) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_ECT_LOADING,
        payload: { configuration: { credentials, ect_fqdn: fqdn } },
      });
      const response = await updateECTForClient(
        clientId,
        businessId,
        fqdn,
        credentials
      );
      if (!response?.response?.success)
        throw new Error(response?.response?.error);
      dispatch({ type: UPDATE_ECT_SUCCESS });
    } catch (error) {
      dispatch({
        type: UPDATE_ECT_ERROR,
        payload: {
          configuration: { credentials: prevCredentials, ect_fqdn: fqdn },
        },
      });
      onFail();
      Bole.alert(ERROR_MESSAGE_SAVE);
    }
  };
};

export const deleteECT = (
  clientId,
  fqdn,
  onFail = () => {},
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DELETE_ECT_LOADING });
      const response = await deleteEctForClient(clientId, fqdn);
      if (!response?.response?.success)
        throw new Error(response?.response?.error);
      dispatch({ type: DELETE_ECT_SUCCESS });
      onSuccess();
    } catch (error) {
      dispatch({ type: DELETE_ECT_ERROR });
      onFail();
      Bole.alert(ERROR_MESSAGE_DELETE);
    }
  };
};

export const activateInvalidBotDialogue = {
  type: ACTIVATE_INVALID_BOT_DIALOGUE,
};

export const deactivateInvalidBotDialogue = {
  type: DEACTIVATE_INVALID_BOT_DIALOGUE,
};

export const activateContactSalesTeamDialog = (toolName) => ({
  type: ACTIVATE_CONTACT_SALES_TEAM_DIALOGUE,
  payload: {
    toolName,
  },
});

export const deactivateContactSalesTeamDialog = {
  type: DEACTIVATE_CONTACT_SALES_TEAM_DIALOGUE,
};
